import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BiChevronRight } from 'react-icons/bi';
import { FaAlignJustify, FaFolder, FaDatabase, FaChartArea, FaBolt, FaCogs, FaRobot } from "react-icons/fa";
import { AuthContext } from '@context';
import useMyMenus from '@hooks/comm/useMyMenus';

const MENU_ICONS = {
  COMM: <FaDatabase />,
  COMP: <FaFolder />,
  ACCI: <FaBolt />,
  DASH: <FaChartArea />,
  AI: <FaAlignJustify />,
  AI_ADMIN: <FaRobot />,
  SYS: <FaCogs />,
};

const Sidebar = ({ activeMenu, isSidebarOpen, isMobile, closeSidebar }) => {
  const { auth } = useContext(AuthContext);
  const location = useLocation();
  const { data: myMenus = [] } = useMyMenus(auth?.isAuthenticated);

  // 🚨 PC(데스크톱)에서는 Header가 서브메뉴를 알아서 그리므로, 여기선 아무 짓도 안 하고 꺼집니다.
  if (!isMobile) return null;
  if (!isSidebarOpen) return null;

  const activeMenuData = myMenus.find(
    menu => menu.menuCode.toLowerCase() === activeMenu
  );

  if (!activeMenuData) return null;

  const icon = activeMenuData ? (MENU_ICONS[activeMenuData.menuCode] ?? <FaFolder />) : null;

  return (
    <div className="fixed inset-y-0 left-0 w-64 translate-x-0 opacity-100 shadow-2xl border-r border-gray-100 h-full bg-[#f0f4f9] z-[9999] transition-transform duration-300">
      <div className="flex flex-col py-6 px-4">
        <div className="flex items-center gap-3 px-3 mb-8">
          <div className="w-8 h-8 rounded-lg bg-blue-100 text-blue-700 flex items-center justify-center shrink-0">
            {icon && React.cloneElement(icon, { size: 18 })}
          </div>
          <h2 className="font-extrabold text-gray-900 tracking-tight text-xl">
            {activeMenuData.menuName}
          </h2>
        </div>

        <ul className="flex flex-col w-full space-y-1">
          {(activeMenuData.children ?? []).map((submenu) => {
            const to = submenu.path || submenu.url || submenu.menuUrl || '/';
            const active = location.pathname === to || location.pathname.startsWith(`${to}/`);

            return (
              <li key={submenu.menuCode} className="flex items-center">
                <Link
                  to={to}
                  onClick={() => closeSidebar()}
                  className={`flex w-full items-center gap-2 px-3 py-3.5 rounded-xl transition-all duration-200 text-base font-bold
                    ${active ? "bg-blue-600 text-white shadow-md" : "text-gray-600 hover:bg-gray-50 hover:text-blue-600"}`}
                >
                  <BiChevronRight className={active ? "text-white" : "text-gray-400"} />
                  <span>{submenu.menuName}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;